import React from 'react'

function Header(props) {
    return <header>
        <h1>Dungeon Generator</h1>
    </header>;
}

export default Header;